import React, { useEffect, useState } from "react";
import { db } from "../firebase";
import { doc, onSnapshot } from "firebase/firestore";

export default function Hero() {
  const [hero, setHero] = useState({
    backgroundUrl: "/assets/sekolah.png",
    title: "Selamat Datang di Website Resmi",
    schoolName: "SMP Muhammadiyah 2 Bolang Dayeuhluhur",
    description: "Tempat tumbuhnya generasi cerdas, berakhlak, dan berprestasi."
  });

  useEffect(() => {
    const docRef = doc(db, "homePage", "hero");
    const unsubscribe = onSnapshot(docRef, (docSnap) => {
      if (docSnap.exists()) setHero(docSnap.data());
    });
    return () => unsubscribe();
  }, []);

  return (
    <div className="hero-container">
      <img
        src={hero.backgroundUrl}
        alt="Hero"
        className="hero-image"
      />
      <div className="hero-overlay"></div>
      <div className="hero-text position-absolute top-50 start-50 translate-middle text-center text-white px-3"
           style={{ textShadow: "2px 2px 8px rgba(0,0,0,0.8)" }}>
        <h1 className="display-4 fw-bold">{hero.title}</h1>
        <h2 className="h3 fw-normal mt-3">{hero.schoolName}</h2>
        <p className="mt-3">{hero.description}</p>
      </div>
    </div>
  );
}
